import React from 'react'

// Soft "subtle" pill badge, consistent with the bg-*-subtle / text-*-emphasis
// treatment already used across the Game Entry Settings wizard.
const StatusBadge = ({ label, tone = 'secondary' }) => (
  <span className={`badge rounded-pill bg-${tone}-subtle text-${tone}-emphasis fw-medium`}>
    {label}
  </span>
)

export default StatusBadge
